/**
 * ModuleName
 *
 * ModuleDescription
 *
 * @return {type}
 */

OT.createNS('OT.Common.Helpers.buildRequestHeaders');

OT.Common.Helpers.buildRequestHeaders = (function buildRequestHeadersWrapper() {
    'use strict';

    return function buildRequestHeaders() {
      var searchData = OT.Search.Data.get();
      var domainCulture = searchData.DomainCulture;
      var requestId, anonymousId;

      try {
          requestId = searchData.Request.Pre['ot-headers']['OT-RequestId'];
          anonymousId = searchData.Request.Pre['ot-headers']['OT-AnonymousId'];
      } catch (err) {
          console.error('Could not retrieve ot-header information', err);
      }

      return {
          'accept-language': domainCulture.Culture,
          'ot-anonymousid': anonymousId,
          'ot-originalhost': window.location.hostname,
          'ot-requestid': requestId,
          'ot-domain': domainCulture.Domain.toString().toLowerCase(),
          'ot-originaluri': window.location.pathname,
          'csrf-token': $('#_csrf').val()
      };
    };
})();
